import { useState } from 'react';
import {
  useEditContext,
  useNotify
} from 'react-admin';
import {
  Button,
  LinearProgress,
  Stack
} from '@mui/material';
import { mapUpsert } from '../utils';
import API_ROOT from '../../../../transport-layer/src/api-root';

const UPSERT_URL = API_ROOT.includes('api.infobate.com')
  ? 'https://htyt2fwh75uv4rxk47y24d74r40pvfuv.lambda-url.us-east-1.on.aws/'
  : 'https://kgnu732xu2gnqccbizubcwupku0pinkt.lambda-url.us-east-2.on.aws/';

const UpsertButton = ({ formData, selectedSchedule, variant="contained" }) => {
  const [loading, setLoading] = useState(false);
  const { record } = useEditContext();
  const id = record?.id || undefined;
  const notify = useNotify();

  const handleClick = async (e) => {
    e.stopPropagation();
    notify(`Triggering upsert for store ${id}...`);
    setLoading(true);

    const body = mapUpsert(record, formData, selectedSchedule);
    console.log(body)

     try {
      const response = await fetch(UPSERT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), 
      });
      if (!response?.ok) throw new Error('Upsert failed');
      notify(`Triggered upsert for store ${id}.`);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notify('Error triggering upsert. Check console for details.');
      console.error(error);
    } 
  };

  return (
    <Stack sx={{ gap: '.5em' }}>
      <Button
        variant={variant}
        onClick={handleClick}
      >
        UPSERT DATA
      </Button>
      {loading && <LinearProgress color="primary" />}
    </Stack>
  );
}

export default UpsertButton;

